import { render, staticRenderFns } from "./base-select-user.vue?vue&type=template&id=3157e6e6&"
import script from "./base-select-user.vue?vue&type=script&lang=ts&"
export * from "./base-select-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports